import { styles as commonStyles } from '../../assets/common.scss';
import { styles } from './template.scss';
import { FontSizes, FontWeights } from '../../types/common/types';
export const template = document.createElement('template');

template.innerHTML = `
<div>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
   <gz-landing-page-template/>
  </div>

  <div class="skeleton">
    <div class="card" style="grid-area: header">
      <gz-title fontWeight=${FontWeights.MEDIUM} fontSize=${FontSizes.TITLE} class="welcome-text">Welcome to</gz-title>
      <div class="large-title d-flex flex-row">
        <gz-title fontSize="48" fontWeight=${FontWeights.BOLD} class="gravity-zone-title">GravityZone</gz-title>
      </div>
      <gz-loader rows="3"></gz-loader>
    </div>
    <div class="card" style="grid-area: header-top">
      <gz-loader rows="3"></gz-loader>
    </div>
    <div class="card" style="grid-area: header-bottom">
      <gz-loader rows="1"></gz-loader>
    </div>
    <div class="card" style="grid-area: integrations">
      <gz-loader rows="2"></gz-loader>
    </div>
    <div class="news" style="grid-area: news">
      <gz-title fontWeight=${FontWeights.MEDIUM} fontSize=${FontSizes.HEADING_3}>
        Latest News
      </gz-title>
      <div class="group">
        <div class="card news-card">
          <div class="image-placeholder"></div>
          <div class="news-footer">
            <gz-loader rows="2"></gz-loader>
          </div>
        </div>
        <div class="card news-card">
          <div class="image-placeholder"></div>
          <div class="news-footer">
            <gz-loader rows="2"></gz-loader>
          </div>
        </div>
        <div class="card news-card">
          <div class="image-placeholder"></div>
          <div class="news-footer">
            <gz-loader rows="2"></gz-loader>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="grid-area: masterclass">
      <gz-loader rows="2"></gz-loader>
    </div>
   </div>

</div>
`;
